@use "/src/styles/functions.scss";
@use "/src/styles/mixins.scss";

$animation-time: functions.speed(fast);

@mixin default {
  transition: all $animation-time ease-in-out;

  background-color: functions.getThemeColor(bg-white-0);

  :global(.icon) {
    color: functions.getThemeColor(icon-sub-600);
  }

  &:has(input:placeholder-shown) {
    :global(.icon) {
      color: functions.getThemeColor(icon-soft-400);
    }
  }

  &::placeholder,
  input::placeholder {
    color: functions.getThemeColor(text-soft-400);
    transition: color $animation-time ease-in-out;
  }
}

@mixin hover {
  &:hover {
    background-color: functions.getThemeColor(bg-weak-50);

    :global(.icon) {
      color: functions.getThemeColor(icon-sub-600) !important;
    }

    &::placeholder,
    input::placeholder {
      color: functions.getThemeColor(text-sub-600);
    }
  }
}

@mixin focus {
  &:focus-within {
    background-color: functions.getThemeColor(bg-weak-50);

    :global(.icon) {
      color: functions.getThemeColor(icon-sub-600) !important;
    }

    &::placeholder,
    input::placeholder {
      color: functions.getThemeColor(text-sub-600);
    }
  }
}

@mixin formControl {
  display: flex;
  gap: functions.space(8);
  align-items: center;
  // padding-inline-start: functions.space(8);
  @include mixins.padding-start(functions.space(8));
  padding-inline-end: functions.space(8);
  min-height: functions.space(36);

  @include default();

  @include hover();

  @include focus();
}

.containerFormControl {
  cursor: text;
  @include formControl();
}
